"use client";

import FooterFive from "@/layouts/footers/FooterFive";
import { useEffect, useState } from "react";
import axiosInstance from "@/service/axiosInstance";
import {
  getSortedSectionsWRTType,
  getSortedSectionsWRTpage,
} from "@/utils/utils";
import Loader from "@/components/Loader/Loader";
import { useSearchParams } from "next/navigation";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "@/redux/features/authSlice";
import { ToastOptions } from "@/utils/enum";
import VivaEventListing from "./event-listing";
import { selectCartItems } from "@/redux/features/cartSlice";
import ClearCart from "../clearCart";

const VivaPreListingOne = () => {
  const dispatch = useDispatch();
  const searchParams = useSearchParams();
  // const redirect: any = searchParams.get("path");
  const [loading, setLoading] = useState(false);
  const [footerData, setFooterData] = useState([[]]);
  const [isPsa, setIsPsa] = useState([[]]);
  const [socialMedia, setSocialMedia] = useState([]);
  const Cart1 = useSelector(selectCartItems);

  const [cartSafe, setCartSafe] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const emptyFilter = {
    eventsType: [],
    eventsMode: [],
    location: "",
    currentPage: 1,
    school: "",
    age: "",
    category: "",
    gender: "",
    zoneSearchBox: "",
    // eventSearchBox: "",
    registrationsOpen: false,
    title: "",
  };

  const getData = async () => {
    try {
      const token = localStorage.getItem("token");
      setLoading(true);

      const resp: any = await axiosInstance.get("/homePage", {});
      if (token) {
        if (
          resp?.isAuthorized?.status == 401 ||
          resp?.isAuthorized?.message == "Token has expired"
        ) {
          console.log("Token has expired!");
          toast.error("Session expired. Please log in again", ToastOptions);
          localStorage.removeItem("token");
          dispatch(logout());

          // router.push(`/login?redirect="true"`);

          // return;
        }
      }

      // let updated = resp?.data;

      // setCount(resp?.meta.pagination.total);

      const footerData1 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 1",
      );

      const footerData2 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 2",
      );

      const footerData3 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 3",
      );
      const socialMediaData = getSortedSectionsWRTpage(
        resp?.data?.data,
        "Social Media",
        "Home Page",
      );
      setSocialMedia(socialMediaData);

      setFooterData([footerData1, footerData2, footerData3]);

      // Create a new object containing the filtered data
      // const filteredApiResponse = { data: filteredData };

      //   setData(resp?.data?.data);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
    if (Cart1.length > 0) {
      setCartSafe(false);
      setShowConfirmModal(true);
    } else {
      setCartSafe(true);
    }
    return () => {
      // dispatch(addFilter(emptyFilter)); // Filters should persist when navigating to cart
    };
  }, []);

  useEffect(() => {
    if (showConfirmModal && Cart1.length === 0) {
      setCartSafe(true);
      setShowConfirmModal(false);
    }
  }, [Cart1, showConfirmModal]);

  return (
    <>
      <html>
        <head>
          <title>
            Exciting Sports Competitions & Games - Vibgyor Viva Event
          </title>
          <meta
            name="description"
            content="Explore a wide range of exciting sports events and competitions at the Vibgyor Viva Event. Join us for thrilling activities, detailed event types, and registration information!"
          />
          <meta
            name="keywords"
            content="sports events, competitions, games, Vibgyor Viva Event"
          />
        </head>
      </html>

      {loading && <Loader />}
      {showConfirmModal && <ClearCart />}
      {cartSafe && <VivaEventListing />}
      {/* <FancyBanner /> */}
      {cartSafe && <FooterFive data={footerData} socialMedia={socialMedia} />}
    </>
  );
};

export default VivaPreListingOne;
